export default function CardIndicador({ label, value, icon, iconClassName = "bg-primary/10 text-primary", onClick, active = false, loading = false, compacto = false }) {
    const clicavel = typeof onClick === "function";

    // Visual mais enxuto (sem ícone, valor em destaque primeiro, sem sombra) usado pelos
    // dashboards de Despesa/Compras — mesma "cara" do dashboard de Pagamento Compensadas. Opt-in
    // só para não afetar as outras telas que já usam este card no estilo padrão.
    if (compacto) {
        return (
            <div
                onClick={onClick}
                className={`bg-card border rounded-lg p-3 transition-all duration-200 ${clicavel ? "cursor-pointer hover:bg-muted/40" : ""} ${active ? "border-primary ring-2 ring-primary/20" : "border-border"}`}
            >
                {loading ? (
                    <div className="h-6 w-16 bg-muted rounded-full animate-pulse" />
                ) : (
                    <p className="text-lg font-bold text-foreground">{value}</p>
                )}
                <p className="text-xs text-muted-foreground truncate">{label}</p>
            </div>
        );
    }

    return (
        <div
            onClick={onClick}
            className={`bg-card border rounded-lg shadow-card overflow-hidden transition-all duration-200 ${clicavel ? "cursor-pointer hover:shadow-soft hover:-translate-y-0.5" : ""} ${active ? "border-primary ring-2 ring-primary/20" : "border-border"}`}
        >
            <div className="p-4 flex justify-between items-center gap-3">
                <div className="min-w-0">
                    <span className="text-sm font-medium text-muted-foreground truncate block">{label}</span>
                    {loading ? (
                        <div className="h-7 w-16 bg-muted rounded-full mt-1 animate-pulse" />
                    ) : (
                        <div className="text-lg font-display font-bold text-foreground mt-1">{value}</div>
                    )}
                </div>
                {icon && (
                    <div className={`p-3 rounded-full shrink-0 ${iconClassName}`}>
                        <i className={icon} />
                    </div>
                )}
            </div>
        </div>
    );
}
